import PropTypes from 'prop-types';
import React from 'react';

import defined from '~app/core/defined';

const WildlifeClassification = ({selectedSpeciesSummary, selectedSpeciesContent}) => {
  if (defined(selectedSpeciesSummary) &&
      defined(selectedSpeciesContent)) {
    const speciesClass = selectedSpeciesContent.class_;
    const speciesOrder = selectedSpeciesContent.order_;
    const speciesFamily = selectedSpeciesContent.family;
    const presence = selectedSpeciesSummary.region_presence;

    return (
      <div className="WildlifeClassification">
        {renderEntry("Class", speciesClass)}
        {renderEntry("Order", speciesOrder)}
        {renderEntry("Family", speciesFamily)}

        {renderEntry("Presence", presence)}
      </div>
    );
  }
  return null;
};

function renderEntry(title, value) {
  if (defined(title) && defined(value)) {
    return (
      <div className="WildlifeClassification__entry">
        <span className="WildlifeClassification__title">
          {`${title.toLowerCase()}: `}
        </span>
        <span className="WildlifeClassification__value">
          {value.toLowerCase()}
        </span>
      </div>
    );
  }
}

WildlifeClassification.propTypes = {
  selectedSpeciesSummary: PropTypes.object,
  selectedSpeciesContent: PropTypes.object,
};

export default WildlifeClassification;



// WEBPACK FOOTER //
// ./src/components/WildlifeClassification.js